import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { INITIAL_STATE } from 'skrit-web-framework/constantes';

import skritApp from '../reducers';

/* Create App Store */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    skritApp,
    INITIAL_STATE,
    composeEnhancers(applyMiddleware(thunkMiddleware))
);

/* End of Create App Store */

export default store;
